import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PaymentGatewayService } from '../../../../core/services/payment-gateway.service';
import { AuthService } from '../../../../core/services/auth.service';

declare var Culqi: any;
declare var window: any;

@Component({
  selector: 'app-checkout-single',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './checkout-single.component.html',
  styleUrl: './checkout-single.component.scss'
})
export class CheckoutSingleComponent implements OnInit {
  private authService = inject(AuthService);
  private authUser = this.authService.getAuthUser();
  ngOnInit(): void {

  }


  private paymentGatewayService = inject(PaymentGatewayService);
  async pay(): Promise<void> {
    const publicKey = environment.culqiPublicKey;

    const settings = {
      title: 'PHOENIX GROUP S.A.C.',
      currency: 'PEN',
      amount: 100, // en centavos
      // order: 'ord_live_0CjjdWhFpEAZlxlz',
      xculqirsaid: environment.culqirsaid,
      rsapublickey: environment.culqiRsaPublicKey,
    };

    const paymentMethods = {
      tarjeta: true,
      yape: true,
      billetera: true,
      bancaMovil: true,
      agente: true,
      cuotealo: true,
    };

    const options = {
      lang: 'auto',
      installments: true,
      modal: true,
      container: '#culqi-container',
      paymentMethods: paymentMethods,
      paymentMethodsSort: Object.keys(paymentMethods),
    };

    const client = {
      email: this.authUser?.email
    };

    console.log('client', client);

    console.log('URL', window.location);

    const appearance = {
      theme: 'default',
      hiddenCulqiLogo: true,
      menuType: "sliderTop",
      logo: `${window.location.origin}/assets/img/logo-responsive-bar.png`,
      defaultStyle: {
        // bannerColor: '#fff',
        // buttonBackground: '#333',
      },
    };

    try {
      await this.paymentGatewayService.initialize(publicKey, settings, client, options, appearance);
      this.paymentGatewayService.openCheckout();
    } catch (error) {
      console.error('Error inicializando Culqi:', error);
    }


  }
}
